function gethsidcardreader(pageObj, dataProp, stateProp, callback) {
	eval('pageObj.' + dataProp + ' = []');
	if (stateProp) {
		eval('pageObj.' + stateProp + ' = true');
	}
	/*window.ax.get('http://127.0.0.1:10909/devsvc?t=gethsidreader').then(rsp => {debugger
	    let data = rsp.data;
	    if (data.Code == 1) {
	        data = data.Data;
	        eval('pageObj.' + dataProp + ' = data');
	        if (callback) {
	            callback(data);
	        }
	    } else {
	        pageObj.$message.error(data.Message);
	    }
	    if (stateProp) {
	        eval('pageObj.' + stateProp + ' = false');
	    }
	}).catch(err => {
	    pageObj.$message.error('执行脚本出错，请联系管理员');
	    if (stateProp) {
	        eval('pageObj.' + stateProp + ' = false');
	    }
	});*/
	var ws = new WebSocket('ws://127.0.0.1:10909');
	ws.onopen = function() {
		ws.send('getidreader');
	};
	ws.onmessage = function(v) {
		console.log(v);
		let idno = v.data.split('|')[5].trim();
		eval('pageObj.' + dataProp + ' = \'' + idno + '\'');
		if (callback) {
			callback(idno);
		}
		if (stateProp) {
			eval('pageObj.' + stateProp + ' = false');
		}
		ws.close();
	};
	ws.onerror = function(v) {
		pageObj.$message.error('连接设备服务失败');
		if (stateProp) {
			eval('pageObj.' + stateProp + ' = false');
		}
	};
};

export default {
	gethsidcardreader
}
